export default {"src":"/_next/static/media/bipoc-owned.c312010d.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};